export default __webpack_public_path__ + "static/media/fiolet_settings.ad5571af.svg";